import { createRouter, createWebHashHistory } from 'vue-router'
import { routes } from './routes'
import { authService } from '@/service/auth/auth_service'
import { DevicePid } from '@/define/define'
import { DeviceManager } from '@/service/device'
import { DialogType, enableDialog } from '@/components/cdialog/dialog'
import i18n from '@/languages/i18n'
import { ConfigShareRouteName } from '@/service/config_share/config_share_routes'
import { shouldPresentApiError } from '@/service/api/api_error_message'

const { t } = i18n.global

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to) => {
  if (to.meta.requiresDevice && DeviceManager.instance.state.currentPid === DevicePid.None) {
    void enableDialog(t('config_share_device_required'), DialogType.notice, false)
    return { name: ConfigShareRouteName.workspace }
  }

  if (to.meta.requiresAuth) {
    try {
      await authService.requireLogin()
    } catch (error) {
      if (shouldPresentApiError(error)) {
        void enableDialog(t('config_share_auth_required'), DialogType.notice, false)
      }
      return false
    }
  }

  return true
})
